import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconCodeBranchSvg } from "./IconCodeBranchSvg.mjs";
const IconCodeBranch = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconCodeBranchSvg, ...iconProps });
};
export {
  IconCodeBranch
};
